export default __webpack_public_path__ + "static/media/GNOSIS.5f339faf.JPG";